module.exports = __webpack_public_path__ + "img/banner1.da3dab38.jpg";